/**
 * Public checkout monetary SSOT: integer agorot (1 ILS = 100 agorot).
 * Rounding: half-up to nearest agorot. Never compare ILS floats.
 */
export const PUBLIC_MONEY_PRICING_VERSION = "public_money_agorot_v1";

export function ilsToAgorot(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100);
}

export function agorotToIls(agorot) {
  if (agorot == null) return null;
  const a = Number(agorot);
  if (!Number.isFinite(a)) return null;
  return a / 100;
}

export function remainingAgorot(payableIls, sumPaidIls) {
  const payable = ilsToAgorot(payableIls);
  const paid = ilsToAgorot(sumPaidIls) || 0;
  if (payable == null) return null;
  return Math.max(0, payable - paid);
}
